import request from "@/utils/request";

// 更多新闻动态的接口
export function getnewsList(){
    return request.get('/home/getNewsList')
}
// 新闻的详情接口
export function getnewsinfoList(id) {
    console.log(id,0);
    return request({
      url: "/home/getNewsInfo",
      method: 'post',
      data:{
        id
      }
    })
  }
 // 列表
  export function getListPageInfo(id) {
    console.log(id,0);
    return request({
      url: "/home/getListPageInfo",
      method: 'post',
      data:{
        id
      }
    })
  }
